<template>
  <div class="card border-inside">
    <div class="card-content">
      <div v-if="$i18n.locale === 'th'" class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Level of business: </span
          >แสดงระดับของผลิตภัณฑ์ในรูปแบบกราฟแท่งแกน x คือระดับของผลิตภัณฑ์
          ส่วนแกน y คือจำนวน Company (ผู้ประกอบการ) ทั้งหมดใน Batch (โครงการ)
          ระดับของผลิตภัณฑ์นั้นจะมีอยู่ทั้งหมด 3 ประเภท
          ซึ่งแต่ละประเภทจะมีระดับของผลิตภัณฑ์แตกต่างกันไป
        </p>
        <ol>
          <li>
            <ul>
              <span class="has-text-weight-normal">ระดับของผลิตภัณฑ์: </span
              >มีระดับทั้งหมดดังนี้
              <li>มีแนวคิดผลิตภัณฑ์หรือบริการ</li>
              <li>MVP (มีผลิตภัณฑ์เพื่อทดสอบแนวความคิดเบื้องต้นแล้ว)</li>
              <li>
                Develop (อยู่ระหว่างการพัฒนาผลิตภัณฑ์ต้นแบบ พร้อมเข้าสู่ตลาด)
              </li>
              <li>Prototype (มีผลิตภัณฑ์ต้นแบบแล้ว)</li>
              <li>Product (ผลิตภัณฑ์แล้ว พร้อมขาย)</li>
              <li>
                Traction
                (ข้อมูลบ่งบอกถึงจำนวนความต้องการของผลิตภัณฑ์หรือบริการจริง)
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <span class="has-text-weight-normal">ระดับของธุรกิจ: </span
              >มีระดับทั้งหมดดังนี้
              <li>Ideation (มีแนวคิดไอเดีย)</li>
              <li>Concepting (มีผลิตภัณฑ์ต้นแบบแล้ว)</li>
              <li>Commitment (มีการทำข้อตกลงร่วมกับคู่ค้าทางธุรกิจแล้ว)</li>
              <li>Validating (ผลิตภัณฑ์หรือบริการมีการทดสอบกับลูกค้าแล้ว)</li>
              <li>Scaling (ขยายตลาด)</li>
            </ul>
          </li>
          <li>
            <ul>
              <span class="has-text-weight-normal">ระดับของเทคโนโลยี: </span
              >มีระดับทั้งหมดดังนี้
              <li>
                Basic principles observed and reported
                (การศึกษาค้นพบและข้อสังเกตพื้นฐาน)
              </li>
              <li>
                Technology concept and/or application formulated
                (การสร้างแนวคิดทางเทคโนโลยี และ/หรือ
                การประยุกต์สูตรทางเทคโนโลยี)
              </li>
              <li>
                Analytical and experimentally critical function and/or
                characteristic proof of concept (การวิเคราะห์และทดลองหน้าที่หลัก
                และ/หรือ การพิสูจน์องค์ประกอบของแนวคิด)
              </li>
              <li>
                Component and/or breadboard validation in laboratory environment
                (การตรวจสอบองค์ประกอบ และ/หรืออุปกรณ์ที่ใช้ทดลอง (breadboard)
                ในระดับห้องปฏิบัติการ)
              </li>
              <li>
                Component and/or breadboard validation in relevant environments
                (การทดสอบองค์ประกอบ และ/หรืออุปกรณ์ที่ใช้ทดลอง (breadboard)
                ในสถานการณ์ที่เกี่ยวข้อง)
              </li>
              <li>
                System/subsystem model or prototype demonstration in a relevant
                environments (การทดลองโมเดลของระบบหลักและระบบย่อย
                หรือต้นแบบในสถานการณ์ที่เกี่ยวข้อง)
              </li>
              <li>
                System prototype demonstration in an operational environment
                (การทดลองต้นแบบในภาคสนาม)
              </li>
              <li>
                Actual system completed and qualified through test and
                demonstration (ระบบจริงที่มีความสมบูรณ์ มีคุณภาพ
                และผ่านการทดสอบและทดลองแล้ว)
              </li>
              <li>
                Actual system proven through successful mission operations
                (ผลงานที่พร้อมส่งมอบและสามารถนําไปใช้งานได้จริง
                โดยผ่านการพิสูจน์เรียบร้อยแล้ว)
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <div v-else class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Level of business: </span
          >Displays the levels of products in a bar graph format. The x-axis
          represents the levels of products, while the y-axis represents the
          total number of companies in the batch. The levels of products can be
          categorized into three types, each with different levels.
        </p>
        <ol>
          <li>
            <ul>
              <span class="has-text-weight-normal">Levels of products: </span
              >There are the following
              <li>
                Product/Service Concept: The idea for the product or service.
              </li>
              <li>
                MVP (Minimum Viable Product): The product has been developed to
                test the initial concept.
              </li>
              <li>
                Develop: The product is in the process of being developed as a
                prototype and preparing for market entry.
              </li>
              <li>Prototype: A prototype of the product has been created.</li>
              <li>
                Product: The product has been manufactured and is ready for
                sale.
              </li>
              <li>
                Traction: Data indicates the actual demand for the product or
                service.
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <span class="has-text-weight-normal">Levels of business: </span
              >There are the following
              <li>
                Ideation: The stage where ideas and concepts are generated.
              </li>
              <li>
                Concepting: The stage where the initial product or service
                prototypes are developed.
              </li>
              <li>
                Commitment: The stage where agreements and partnerships with
                business counterparts are established.
              </li>
              <li>
                Validating: The stage where the product or service is tested and
                validated with customers.
              </li>
              <li>
                Scaling: The stage where the business expands its market
                presence and operations.
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <span class="has-text-weight-normal">Levels of technology: </span
              >There are the following
              <li>
                Basic principles observed and reported: The stage where
                fundamental principles and observations are studied and
                documented.
              </li>
              <li>
                Technology concept and/or application formulated: The stage
                where technology concepts and/or applications are developed.
              </li>
              <li>
                Analytical and experimentally critical function and/or
                characteristic proof of concept: The stage where critical
                functions and/or characteristics of the technology are analyzed,
                experimented with, and conceptually proven.
              </li>
              <li>
                Component and/or breadboard validation in laboratory
                environment: The stage where components and/or breadboard models
                are validated in a controlled laboratory setting.
              </li>
              <li>
                Component and/or breadboard validation in relevant environments:
                The stage where components and/or breadboard models are tested
                and validated in environments relevant to their intended
                application.
              </li>
              <li>
                System/subsystem model or prototype demonstration in relevant
                environments: The stage where system/subsystem models or
                prototypes are demonstrated in environments that closely
                resemble their intended real-world application.
              </li>
              <li>
                System prototype demonstration in an operational environment:
                The stage where system prototypes are demonstrated and tested in
                real operational environments.
              </li>
              <li>
                Actual system completed and qualified through test and
                demonstration: The stage where the actual system is fully
                completed, tested, and qualified through comprehensive testing
                and demonstration.
              </li>
              <li>
                Actual system proven through successful mission operations: The
                stage where the actual system has been successfully deployed and
                proven through operational missions.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>